/**
 * Append Mega Menus to menu-item's
 */

export function appendMegaMenus( cssSelector = '.site-megamenus-container > .sub-menu' ) {
    // Append Mega Menu to menu-item
    $( cssSelector ).each(function(i) {
        console.log( $(this).attr('data-append-to-menu') );
        let appendTo = $(this).attr('data-append-to-menu') ? $(this).attr('data-append-to-menu') : false;
        if ( appendTo !== false ) {
            let $target_menuitem =  $('.site-bar .site-navigation ' + appendTo);
            if ( $target_menuitem.find('.sub-menu') ) {
                let $remove_submenu = $target_menuitem.find('.sub-menu');
                $remove_submenu.remove();

                $target_menuitem.append( $(this) );
            } else {
                $target_menuitem.append( $(this) );
            }
            $target_menuitem.addClass('menu-item-has-children has-megamenu');
        }
    });
}

/**
 * Align Mega Menus
 */

 export function alignMegaMenus( cssSelector = '.site-navigation__nav > .menu-item' ) {
     const $menuitem = $( cssSelector );
           
     $menuitem.each( function( i ) {
         const $menu = $(this);
         const $submenu = $menu.find('.sub-menu'); 

         if ( $submenu.length > 0 ) {

             let menuitem_offset = $menu.get(0).offsetLeft;
             let menuitem_width = $menu.get(0).offsetWidth;

             let submenu_offset = $submenu.offset().left;
             let submenu_width = $submenu.get(0).offsetWidth;

             // 1. Establish center point of link
             let menuitem_center = menuitem_offset + ( menuitem_width / 2 ) + delta;

             // 2. Establish the center point of the submenu
             let submenu_center = submenu_width / 2;

             var delta = -5; // Random number used to message the offset

             $submenu.get(0).style.transform = `translateX(-${ submenu_center - ( ( menuitem_width / 2 ) + delta ) }px)`;
             
             // ** Testing only
             var child_index = -1; // Set to negative to prevent display of 'test-divs' below 
             
             if ( i == child_index ) {
                 $submenu.addClass('TESTING');
                 $('body').prepend(`
                     <div class="test-divs" id="menuitem-offsetr" style="width: ${menuitem_offset}px; height: 2px; background-color: orange; z-index: 1000; position: absolute; top: 0; left: 0px;"></div>
                     <div class="test-divs" id="menuitem-center" style="width: ${menuitem_center}px; height: 2px; background-color: red; z-index: 1000; position: absolute; top: 4px; left: 0;"></div>
                     <div class="test-divs" id="menuitem-half" style="width: ${( menuitem_width / 2 ) + delta}px; height: 2px; background-color: limegreen; z-index: 1000; position: absolute; top: 8px; left: ${menuitem_offset}px;"></div>
                     <div class="test-divs" id="submenu-center" style="width: ${submenu_center}px; height: 2px; background-color: blue; z-index: 1000; position: absolute; top: 12px; left: ${submenu_offset}px;"></div>
                 `);
             }

         }

     } );

 }